module.exports = __webpack_public_path__ + "static/media/ws-conf-dark-logo.d2a03a08.svg";